
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return /^(vendors\-node_modules_(react\-(router(\-dom_dist_index|_dist_development_chunk\-JZWAC4HX)_mjs|dom_index_js\-node_modules_react_index_js\-node_modules_rspack_plugi\-1cd392)|ckeditor_ckeditor5\-react_dist_ckeditor_js\-node_modules_react\-bootstrap\-t\-3fd855)|index|lib\-axios|node_modules_countup_js_dist_sync_recursive\-node_modules_moment_locale_sync_recursive_\-src_bo\-469bf6)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}

if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return /^(vendors\-node_modules_(react\-(router(\-dom_dist_index|_dist_development_chunk\-JZWAC4HX)_mjs|dom_index_js\-node_modules_react_index_js\-node_modules_rspack_plugi\-1cd392)|ckeditor_ckeditor5\-react_dist_ckeditor_js\-node_modules_react\-bootstrap\-t\-3fd855)|index|lib\-axios|node_modules_countup_js_dist_sync_recursive\-node_modules_moment_locale_sync_recursive_\-src_bo\-469bf6)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
